import React, { Component } from "react";
import ConteudoQuestionario from "./ConteudoQuestionario";
import Controlos from "../../components/Controlos.jsx";
import ControlosSimples from "../../components/ControlosSimples.jsx";
import LazyLoad from "react-lazy-load";
import Oops from "../../../../pages/Oops.jsx";

import { iconQuestionarioProgresso } from "../../../../assets/tipoDeConteudos";

class Questionario extends Component {
    state = {
        nome: "",
        objetivos: "",
        questoes: 0,
        dataHora: "",
        //NAO DISPONIVEL
        nao_disponivel: false,
        sameUrl: true
    };

    UNSAFE_componentWillReceiveProps(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.setState(
                {
                    sameUrl: false
                },
                () =>
                    this.setState({
                        sameUrl: true
                    })
            );
        }
    }

    marcarComoNaoDisponivel = () => {
        this.setState({
            nao_disponivel: true
        });
    };

    render() {
        const {
            nome,
            objetivos,
            questoes,
            dataHora,
            //NAO DISPONIVEL
            nao_disponivel,
            sameUrl
        } = this.state;

        return (
            <div className="questionario">
                <div className="player-wrapper">
                    {!nao_disponivel ? (
                        <>
                            <ConteudoQuestionario
                                marcarComoNaoDisponivel={this.marcarComoNaoDisponivel}
                                carregarInfo={(nome, objetivos, questoes) => this.setState({ nome, objetivos, questoes })}
                            />
                            <Controlos
                                backUrl={
                                    localStorage.getItem("player_back_url")
                                        ? localStorage.getItem("player_back_url")
                                        : `/gerir-curso/${this.props.match.params.curso.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/curso-modulos`
                                }
                                sameUrl={sameUrl}
                                temAnotacoes
                                temInformacoes
                                nome={nome}
                                objetivos={objetivos}
                                questoes={questoes}
                                icon={iconQuestionarioProgresso}
                                dataHora={dataHora}
                            />
                        </>
                    ) : (
                        <>
                            <div className="container">
                                <div className="bloco-nao-disponivel">
                                    <div className="bloco-info nao-disponivel">
                                        <Oops tem_texto texto={"Conteúdo não disponível"} />
                                    </div>
                                </div>
                            </div>
                            <ControlosSimples />
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default Questionario;
